import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <div className="logo-icon">
            <img src="/images/logo_Favicon/bubbles-balloons-logo.png" alt="Bubbles & Balloons Logo" width="40" height="40" />
          </div>
          <span className="logo-text">Bubbles & Balloons</span>
        </div>
        
        <nav className="nav-menu">
          <a href="#home" className="nav-link">Home</a>
          <a href="#decorations" className="nav-link">Decorations</a>
          <a href="#about" className="nav-link">About</a>
          <a href="#services" className="nav-link">Services</a>
          <a href="#contact" className="nav-link">Contact Us</a>
        </nav>

        <a href="https://wa.me/919910980273" className="enquiry-btn" target="_blank" rel="noopener noreferrer">Enquiry Now</a>
      </div>
    </header>
  );
};

export default Header;
